import axiosStuffedDetector from 'config/axiosDetectStuffedKeywords';
import axiosPrivate from 'config/axiosPrivate';

import { animationUrl } from 'config/endpoints';

import { transformToSemanticGap } from 'helpers/FormatKeywordsHelper';
import { isValidFormat } from 'helpers/PdfFunction';
import { useDispatch } from 'react-redux';

import { updateForm } from 'store/Writer/Analyser';

import { KeywordStuffingModalPrompts } from 'utils/Constants';

export const useWriterPutToDraft = ({
  textType,
  combinedKeywords,
  url,
  initialTextContent,
  orderType,
  orderContentType,
  actualHtmlContent,
  actualTextContent,
  analyseResult,
  initialHtmlContent,
  currentContentScore,
  keyword,
  metaDescriptionTag,
  textTitle,
  titleTag,
  actualTextWordCount,
  initialTextWordCount,
  stuffedKeywords,
  websites,
  initialStuffedKeywords,
  formData,
  orderId,
  t,
  setShowKeywordStuffingModal,
  isEmpty,
  setErrorSuccessMsg,
  setIsSuccess,
  setErrorSuccess,
  setIsFetchLoading,
  setErrorSuccessImg,
}) => {
  const dispatch = useDispatch();

  const putToDraft = async (demandeRevision = '', finalHtmlContent) => {
    const isKeywordsValid =
      textType !== 'TRANSLATED' ? isValidFormat(combinedKeywords) : {};

    const semanticGap = transformToSemanticGap(combinedKeywords);
    const isSmartWithReviewGMB =
      orderType === 'SMART_WITH_REVIEW' && orderContentType === 'GMB';

    if (
      !isKeywordsValid &&
      textType !== 'TRANSLATED' &&
      !isSmartWithReviewGMB
    ) {
      setErrorSuccessMsg(
        ` ${t(
          'Veuillez corriger le format de votre gap sémantique afin de pouvoir sauvegarder le texte en brouillon'
        )}. `
      );
      setIsSuccess(false);
      setErrorSuccess(true);
      return;
    }

    if (orderType === 'PREMIUM') {
      if (!isEmpty(url) && isEmpty(initialTextContent)) {
        setErrorSuccessMsg(
          ` ${t(
            'Veuillez ajouter un texte initiale afin de pouvoir sauvegarder le texte en brouillon'
          )}. `
        );
        setIsSuccess(false);
        setErrorSuccess(true);
        return;
      } else if (isEmpty(url) && !isEmpty(initialTextContent)) {
        setErrorSuccessMsg(
          ` ${t(
            'Veuillez ajouter une url afin de pouvoir sauvegarder le texte en brouillon'
          )}. `
        );
        setIsSuccess(false);
        setErrorSuccess(true);
        return;
      }
    }

    // Use the provided content if it exists, otherwise fall back to the state.
    const contentToSave =
      finalHtmlContent !== undefined ? finalHtmlContent : actualHtmlContent;

    const requestData = {
      activeInitialText: false,
      actualHtmlContent: contentToSave,
      actualTextContent: actualTextContent,
      analyseResult: analyseResult && JSON.stringify(analyseResult),
      initialHtmlContent: initialHtmlContent,
      initialTextContent: initialTextContent,
      keyword: keyword,
      metaDescriptionTag: metaDescriptionTag,
      semanticGap: semanticGap,
      textTitle: textTitle,
      titleTag: titleTag,
      totalNumberOfTextAdded:
        actualTextContent && textType === 'NON_TRANSLATED'
          ? actualTextWordCount - initialTextWordCount
          : actualTextWordCount,

      url: url,
      type: textType,
      stuffedKeywords: stuffedKeywords,
      internalLinking: websites,
      initialStuffedKeywords: initialStuffedKeywords,
      // Include current contentScore from sidebar
      contentScore: currentContentScore,
    };

    const handleSuccess = (res) => {
      setIsFetchLoading(false);
      dispatch(updateForm(res.data));
      if (demandeRevision === 'keywordStuffingDraft') {
        setErrorSuccessMsg(
          t(KeywordStuffingModalPrompts.successDemandeRevisionKeywordStuffing)
        );
        axiosStuffedDetector
          .post(`/texts/keywordStuffing/notifyAdmin`, res.data['id'], {
            headers: {
              accept: 'application/json',
              'Content-Type': 'application/json',
            },
          })
          .then((response) => {
            setErrorSuccessMsg(
              t(
                KeywordStuffingModalPrompts.successDemandeRevisionKeywordStuffing
              )
            );
            setShowKeywordStuffingModal(false);
            setIsSuccess(true);
            setErrorSuccess(true);
          })
          .catch((err) => {
            setErrorSuccessMsg(
              t(KeywordStuffingModalPrompts.errorDemandeRevisionKeywordStuffing)
            );
            setShowKeywordStuffingModal(false);
            setIsSuccess(false);
            setErrorSuccess(true);
          });
      }
      if (demandeRevision === '') {
        setErrorSuccessMsg(
          `${t('Le texte')} ${formData?.textTitle || textTitle}  ${t(
            'a été mis en brouillon'
          )}!`
        );
        setErrorSuccessImg(animationUrl + '/04_Contenu_validé.gif');
      }
      setIsSuccess(true);
      setErrorSuccess(true);
    };

    const handleError = (e) => {
      setIsFetchLoading(false);

      switch (e.response.status) {
        case 400:
          setErrorSuccessMsg(
            `${t(
              'Veuillez changer les informations suivantes titre et/ou mot clé'
            )}`
          );
          break;
        default:
          setErrorSuccessMsg(`Oups...! ${t("Une erreur s'est produite")}. `);
          break;
      }
      setIsSuccess(false);
      setErrorSuccess(true);
    };

    setIsFetchLoading(true);

    if (formData) {
      axiosPrivate
        .put(`/texts/${formData.id}`, requestData)
        .then((res) => {
          handleSuccess(res);
        })
        .catch((e) => {
          handleError(e);
        });
    } else {
      const postRequestData = {
        ...requestData,
        commandId: orderId,
      };

      axiosPrivate
        .post('/texts', postRequestData)
        .then((res) => {
          handleSuccess(res);
        })
        .catch((e) => {
          handleError(e);
        });
    }
  };

  return { putToDraft };
};
